// extracted by mini-css-extract-plugin
export default {"grid":"gallery_grid__m5oeN","gridImage":"gallery_gridImage__tyFI2","lightbox":"gallery_lightbox__qE4S2","closeButton":"gallery_closeButton__f9L-y"};